/*
 * @Description:
 * @Date: 2020-09-25 09:45:01
 * @LastEditors: wjx
 */
import {
  Button,
  Swipe,
  SwipeItem,
  Lazyload,
  PullRefresh,
  Toast,
  Popup,
  Picker,
  Field,
  Cell,
  CellGroup,
  Notify,
  List,
  Calendar,
  Form,
  Search,
  Icon,
  Rate,
  Uploader,
  DatetimePicker,
  Dialog,
  Area,
  Sticky,
  Tab,
  Tabs,
  Loading,
  ActionSheet,
  Checkbox,
  CheckboxGroup
} from 'vant';

export default {
  install(Vue, options) {
    Vue.use(Picker);
    Vue.use(Popup);
    Vue.use(Toast);
    Vue.use(PullRefresh);
    Vue.use(Button);
    Vue.use(Swipe).use(SwipeItem);
    Vue.use(Lazyload);
    Vue.use(Field);
    Vue.use(Cell).use(CellGroup);
    Vue.use(Notify);
    Vue.use(List);
    Vue.use(Calendar);
    Vue.use(Form);
    Vue.use(Search);
    Vue.use(Icon);
    Vue.use(Rate);
    Vue.use(Uploader);
    Vue.use(DatetimePicker);
    Vue.use(Sticky);
    Vue.use(Tab);
    Vue.use(Tabs);
    Vue.use(Loading);
    Vue.use(ActionSheet);
    Vue.use(Dialog);
    Vue.use(Area);
    Vue.use(Checkbox);
    Vue.use(CheckboxGroup);
  }
};
